import Image from 'next/image';
import styled from '@emotion/styled';
import { media } from '@/styles/tokens';

interface InnerProps {
  firstContent: boolean;
}

interface TitleProps {
  color: string;
}

interface ImageBoxProps {
  firstContent: boolean;
  backgroundColor: string | undefined;
}

export const Container = styled.section`
  position: relative;
`;

export const Inner = styled.div<InnerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 80px 0 60px;
  ${({ firstContent }) => !firstContent && 'max-width: 1440px;'}
  width: 100%;

  ${media.mobile} {
    padding: ${({ firstContent }) => (firstContent ? '40px 0 0' : '80px 0 0')};
  }
`;
export const EyeBrow = styled.p`
  margin-bottom: 12px;
  text-align: center;
  color: #727272;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
`;
export const Title = styled.h1<TitleProps>`
  margin-bottom: 30px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  line-height: 48px;

  ${media.mobile} {
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    line-height: 34px;
    word-break: break-all;
  }

  & > strong {
    font-weight: 700;
    background: ${({ color }) => color};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const SectionTitle = styled.h2<TitleProps>`
  margin-bottom: 30px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  line-height: 48px;

  ${media.mobile} {
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    line-height: 34px;
    word-break: break-all;
  }

  & > strong {
    font-weight: 700;
    background: ${({ color }) => color};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Description = styled.p`
  position: relative;
  width: fit-content;
  text-align: center;
  color: #121212;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;

  &::before {
    content: '•';
    position: absolute;
    top: -2px;
    left: -14px;
    width: 4px;
    height: 4px;
    color: black;
  }

  ${media.mobile} {
    color: #282828;

    text-align: center;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.48px;

    &::before {
      content: none;
    }
  }
`;
export const ImageBox = styled.div<ImageBoxProps>`
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: end;
  width: ${({ firstContent }) => (firstContent ? ' 100%;' : 'auto')};
  height: ${({ firstContent }) => (firstContent ? '612px' : 'auto')};
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '#fff')};
  ${({ firstContent }) => !firstContent && 'border-radius: 24px;'};

  ${media.mobile} {
    margin-top: 50px;
    height: auto;
    ${({ firstContent }) => firstContent && 'padding: 80px 48px 0 '}
  }
`;
export const Img = styled(Image)``;
